//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "conpon",
  data(){
      return {
        tabIndex:1,
        conponList:[]
      }

  },
  methods:{
    getConpon(){
      this.$vux.loading.show()
      this.conponList=[];
      this.axios.post('/xcx/User/coupon',{lx:this.tabIndex}).then(res=>{
        this.conponList=res.data.data
        this.$vux.loading.hide();
      })
    },
    changeTab(index){
      if(index!=this.tabIndex){
        this.tabIndex=index;
        this.getConpon();
      }

    }
  },
  created() {
    this.getConpon();
  }
}



// WEBPACK FOOTER //
// ./src/components/conpon/conpon.vue